import {
  Field,
  FieldControllerType,
  FormBuilder,
  FormBuilderContainer,
  GenericObj,
} from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { usePatientStore } from '@store/patientStore';
import { FormIds } from '@utils/enums/FormIds.enum';
import { useTranslation } from 'react-i18next';

interface NewPatientSectionProps {
  setEnableButton: (val: boolean) => void;
}

export const NewPatientSection = ({
  setEnableButton,
}: NewPatientSectionProps) => {
  const setIsNewPatientStarted = useOnlineBookingStore(
    state => state.setIsNewPatientStarted,
  );
  const { t } = useTranslation();
  const setCurrentPatient = useOnlineBookingStore(
    state => state.setCurrentPatient,
  );
  const setShowAddPatientFrame = useOnlineBookingStore(
    state => state.setShowAddPatientFrame,
  );
  const updatePatient = usePatientStore(state => state.updatePatient);
  const patients = usePatientStore(state => state.patients);

  const setPatientOrder = usePatientStore(state => state.setPatientOrder);

  const newPatientField: Field = {
    labelKey: t('newPatientPage.description').replace(
      '{{maxPatientsPlaceholder}}',
      patients.filter(p => p).length > 1
        ? t('newPatientPage.one')
        : t('newPatientPage.two'),
    ),
    id: 'newPatientRadio',
    size: {
      xs: 12,
      md: 12,
      lg: 12,
    },
    type: FieldControllerType.RADIO,
    visibility: true,
    validations: [
      {
        type: 'required',
        value: true,
        errorMsgKey: 'fieldsLabel.errors.isRequired',
      },
    ],
    options: [
      { label: 'Yes', key: 'yes' },
      { label: 'No', key: 'no' },
    ],
    otherOptions: {
      radio: {
        wrapLabelText: true,
        variant: 'textMdRegular',
      },
    },
  };

  const handleNewPatient = (
    formData: { newPatientRadio: 'yes' | 'no' } | GenericObj | undefined,
  ) => {
    console.log('#unmount.newPatientSection');
    const onlyTruePatient = patients.filter(p => p);
    if (
      formData &&
      formData.newPatientRadio === 'yes' &&
      onlyTruePatient.length < 3
    ) {
      const newPatientIndex = patients.findIndex(p => !p);
      const maxOrderPatient =
        patients.reduce((acc, patient) => {
          if (patient?.order) {
            return Math.max(acc, patient.order);
          }
          return acc;
        }, 0) + 1;

      updatePatient(newPatientIndex, FormIds.AppointmentType, {});
      setIsNewPatientStarted(true); // redirect to ApptType page
      setShowAddPatientFrame(false);
      setPatientOrder(newPatientIndex, maxOrderPatient);
      setCurrentPatient(newPatientIndex);
    }
  };

  return (
    <FormBuilderContainer
      key={'newPatientForm'}
      optionForm={{
        defaultValues: {},
        mode: 'onChange',
      }}
      setEnableButton={e => {
        setEnableButton(e);
      }}
      onUnmount={(formData: GenericObj | undefined) =>
        handleNewPatient(formData)
      }
    >
      <FormBuilder form={[newPatientField]} defaultValues={{}}></FormBuilder>
    </FormBuilderContainer>
  );
};
